import React, { memo } from 'react'
import { Security } from '../../proto/generated/security'
import { OverviewWidgetResponse_FieldGroup, OverviewWidgetResponse_IndexComponent } from '../../proto/generated/overview-widget'
import IndexComponents from './IndexComponents'
import SecurityOverviewFieldGroups from './SecurityOverviewFieldGroups'
import SeasonalsSection from './SeasonalsSection'
import TechnicalsSection from './TechnicalsSection'
import CommunityScreenChips from './CommunityScreenChips'

export type ScreenerOverviewDetailsProps = {
    indexComponents: OverviewWidgetResponse_IndexComponent[]
    fieldGroups: OverviewWidgetResponse_FieldGroup[]
    securityForContent: Security | undefined
    screenerTargetKey: string | null
    overviewSecurityKey: string | undefined
}

const detailsPropsAreEqual = (prev: ScreenerOverviewDetailsProps, next: ScreenerOverviewDetailsProps) =>
    prev.indexComponents === next.indexComponents &&
    prev.fieldGroups === next.fieldGroups &&
    prev.securityForContent === next.securityForContent &&
    prev.screenerTargetKey === next.screenerTargetKey &&
    prev.overviewSecurityKey === next.overviewSecurityKey

const ScreenerOverviewDetails = ({
    indexComponents,
    fieldGroups,
    securityForContent,
    screenerTargetKey,
    overviewSecurityKey
}: ScreenerOverviewDetailsProps) => (
    <>
        <IndexComponents indexComponents={indexComponents} />
        <SecurityOverviewFieldGroups
            fieldGroups={fieldGroups}
            currentVisibleOverviewSecurity={securityForContent}
            isOnScreener
            screenerTargetKey={screenerTargetKey}
            overviewSecurityKey={overviewSecurityKey}
            securityForContent={securityForContent}
        />
        <CommunityScreenChips security={securityForContent} />
        <SeasonalsSection security={securityForContent} />
        <TechnicalsSection security={securityForContent} />
    </>
)

export default memo(ScreenerOverviewDetails, detailsPropsAreEqual)
